import { Modal } from '@/components/common/Modal'
import { WhatIfBody } from './WhatIfBody'

interface Props {
  open: boolean
  onClose: () => void
  initialPositionId?: number | null
  initialSellPct?: string
}

export function WhatIfModal({ open, onClose, initialPositionId, initialSellPct }: Props) {
  return (
    <Modal open={open} onClose={onClose} title="What-if-Simulator" widthClass="max-w-6xl">
      <WhatIfBody
        initialPositionId={initialPositionId}
        initialSellPct={initialSellPct ?? '0'}
        onCommitSuccess={() => {
          // Modal stays open — success banner inside WhatIfBody gives UX feedback.
          // Caller can close manually via onClose.
        }}
      />
    </Modal>
  )
}
